import React from 'react';
import Site2Layout from './Site2Layout';

// Single-layout app since 18 Aug 2026: the /legacy mirror (old top-NavBar
// chrome) is retired and NavBar.js deleted. Everything renders under the
// Site2 sidebar layout; /legacy/* URLs redirect in App.js.
const Layout = ({ children }) => <Site2Layout>{children}</Site2Layout>;

export default Layout;
